import React, { useState } from 'react';
import {
  Pane,
  Heading,
  Paragraph,
  Button,
  Text,
  RadioGroup,
  Card,
  majorScale,
  Badge,
} from 'evergreen-ui';
import { useNavigate } from 'react-router-dom';
import useStore from '../appservices/store'; // Zustand store for authentication status

 
 
function PricingPage() {
  const [billingCycle, setBillingCycle] = useState('Annual billing');
  const navigate = useNavigate();
  const { user, setSelectedPlan, setSelectedPriceId } = useStore(); // Access Zustand actions and state

  // Function to handle plan selection and proceed accordingly
  const handlePlanSelection = (plan, productId) => {
    // Store selected plan and product ID in Zustand store
    setSelectedPlan(plan);
    setSelectedPriceId(productId);

    if (user) {
      // If user is authenticated, proceed directly to checkout
      navigate('/checkout');
    } else {
      // If not authenticated, redirect to auth page with selected plan and billing info
      navigate(`/auth?plan=${plan}&billing=${billingCycle}&productId=${productId}`);
    }
  };

  return (
    <Pane id="pricing" display="flex" flexDirection="column" alignItems="center" padding={majorScale(4)}>
      <Heading size={900} marginBottom={16} textAlign="center" fontWeight={600} style={{ fontSize: '36px' }}>
        Flexible Plans for Your Needs
      </Heading>
      <Paragraph size={500} textAlign="center" maxWidth="700px" marginBottom={32} style={{ fontSize: '18px', color: '#5B5B5B' }}>
        24/7 AI Tech Support for Home and Businesses. Choose the plan that fits your needs and enjoy uninterrupted support.
      </Paragraph>

      <Pane display="flex" justifyContent="center" alignItems="flex-start" gap={majorScale(5)} maxWidth={1200} flexWrap="wrap">
        {/* Home Plan */}
        <Card padding={majorScale(3)} background="white" borderRadius={8} elevation={1} width={320} minHeight={400}>
          <Heading size={700} marginBottom={8} fontWeight={600}>
            Home
          </Heading>
          <Paragraph size={400} color="muted" marginBottom={16}>
            Affordable AI tech support for your home devices
          </Paragraph>
          <Heading size={900} marginBottom={8} style={{ fontSize: '28px', fontWeight: '700' }}>
            ${billingCycle === 'Annual billing' ? '19.99' : '24.99'}/mo
          </Heading>
          <Paragraph size={400} color="muted" style={{ fontSize: '14px', marginBottom: '16px' }}>
            per user billed {billingCycle === 'Annual billing' ? 'annually' : 'monthly'}.
          </Paragraph>
          <Button
            appearance="primary"
            marginTop={16}
            width="100%"
            height={48}
            fontSize={16}
            onClick={() => handlePlanSelection('Home', 'price_1OxJGMHxM7j6JEg1K59lygj7')}
          >
            Get started
          </Button>
        </Card>

        {/* Business Plan */}
        <Card padding={majorScale(3)} background="white" borderRadius={8} border="2px solid #3366FF" width={320} minHeight={400}>
          <Pane display="flex" justifyContent="space-between" alignItems="center" marginBottom={8}>
            <Heading size={700} fontWeight={600}>
              Business
            </Heading>
            <Badge color="blue" marginBottom={8}>
              Popular
            </Badge>
          </Pane>
          <Paragraph size={400} color="muted" marginBottom={16}>
            Comprehensive support for small and growing businesses
          </Paragraph>
          <Heading size={900} marginBottom={8} style={{ fontSize: '28px', fontWeight: '700' }}>
            ${billingCycle === 'Annual billing' ? '49.99' : '59.99'}/mo
          </Heading>
          <Paragraph size={400} color="muted" style={{ fontSize: '14px', marginBottom: '16px' }}>
            per user billed {billingCycle === 'Annual billing' ? 'annually' : 'monthly'}.
          </Paragraph>
          <Button
            appearance="primary"
            marginTop={16}
            width="100%"
            height={48}
            fontSize={16}
            onClick={() => handlePlanSelection('Business', 'price_1OxJGLHxM7j6JEg1QmW6GbGA')}
          >
            Get started
          </Button>
        </Card>
      </Pane>
    </Pane>
  );
}

export default PricingPage;
